import React from "react";
import { Icon } from "components";
import { INFO } from "icons";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "ui/components/tooltip";

export const TooltipInfo = ({ info }) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip variant="ghost">
        <TooltipTrigger asChild>
          <Icon icon={INFO} className="size-4" />
        </TooltipTrigger>
        <TooltipContent side="top" className="text-sm max-w-xs">
          {info}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
